import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService, AuthState } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  auth = inject(AuthService);
  private router = inject(Router);
  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    // If a token
    if (this.auth.authState && this.auth.authState === AuthState.loggedIn) {
      return true; // logged in and has apiUrl so set true
    }
    const parsedUrl = this.router.parseUrl(this.router.url);
    const segments =
      parsedUrl.root.children.hasOwnProperty('primary') && parsedUrl.root.children['primary'].hasOwnProperty('segments')
        ? parsedUrl.root.children['primary']['segments']
        : [];
    const isLoginComponent = segments.findIndex(segment => segment.path === 'login') !== -1;

    if (!isLoginComponent) {
      this.auth.logOut(AuthState.loggedOut, { currentUrl: _state.url });
    }

    return false;
  }
}
